<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
    <a-modal title="代办工单" :width="1200" :open="true" :confirmLoading="state.loading" :maskClosable="false"
        @ok="onFormSubmit" @cancel="cancel" :footer="null">
        <a-card :bordered="false">
            <div class="table-page-search-wrapper">
                <a-form>
                    <a-row :gutter="48">
                        <a-col :md="6" :sm="24">
                            <a-form-item label="标题">
                                <a-input v-model:value="queryParam.title" placeholder="标题"></a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <span class="table-page-search-submitButtons">
                                <a-button type="primary" @click="loadData">查询</a-button>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
            <a-table :columns="columns" :loading="state.loading" :data-source="dataSource" :pagination="pagination"
                @change="onChange" rowKey="id">
                <template #bodyCell="{ column, record, index, text }">
                    <template v-if="column.dataIndex == 'type'">
                        <a-tag :color="record.type == 1 ? 'red' : record.type == 2 ? 'black' : 'blue'">{{
                            typeMap.get(record.type) }}</a-tag>
                    </template>
                    <template v-else-if="column.dataIndex === 'operate'">
                        <a @click="handleDetail(record)">详情</a>
                    </template>
                </template>
            </a-table>
        </a-card>
        <a-modal v-model:open="state.showDetail" title="📮 工单详情" :width="'85%'" :style="{ width: '800px', top: '30px' }"
            :bodyStyle="{ maxHeight: 'calc(100vh - 180px)', overflowY: 'auto', overflowX: 'hidden' }" @ok="oncancel"
            @cancel="oncancel">
            <a-form v-bind="formLayout" v-if="state.detailData">
                <a-form-item label="工单标题">
                    {{ state.detailData.title }}
                </a-form-item>
                <a-form-item label="工单内容">
                    {{ state.detailData.content }}
                </a-form-item>
                <a-form-item label="工单附件">
                    <span v-for="(item, index) in state.detailData.attachment">
                        <a-image
                            v-if="item.name.indexOf('jpg') > -1 || item.name.indexOf('png') > -1 || item.name.indexOf('jpeg') > -1"
                            :key="index" :width="100" :height="100" :src="$store.state.user.image_domain + item.url">
                        </a-image>
                        <a v-else :href="$store.state.user.image_domain_a + item.url" download target="_blank">{{
                            item.name }}</a>
                    </span>
                </a-form-item>
            </a-form>
        </a-modal>
    </a-modal>
</template>
<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, computed, handleError } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import type { PaginationProps } from 'ant-design-vue'
import BetweenTimePick from '@/components/base/BetweenTimePick.vue'
import { useStore } from 'vuex'
const $store = useStore()
const emit = defineEmits(['ok', 'cancel'])
const props = defineProps({
    detailData: {
        type: Object,
        default: () => null
    }
})
const columns = [
    {
        title: '工单标题',
        dataIndex: 'title',
        width: 550
    },
    {
        title: '类型',
        dataIndex: 'type',
        width: 100
    },
    {
        title: '时间',
        dataIndex: 'created_at',
        width: 200
    },
    {
        title: '操作',
        dataIndex: 'operate',
        width: 200
    }
]
interface state {
    loading: boolean
    detailData: object
    showDetail: boolean
}
const state = reactive<state>({
    loading: false,
    detailData: {},
    showDetail: false
})
const typeMap = new Map([
    [1, '投诉'],
    [2, '举报'],
    [3, '代办事项'],
    [4, '待通知信函'],
    [5, '其他事项']
])
let queryParam = reactive<any>({
})
let dataSource = ref([])
const pagination = reactive<PaginationProps>({
    pageSize: 10,
    pageSizeOptions: ['10', '50', '100', '200', '1000', '2000'],
    current: 1,
    total: undefined,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `总数：${total}`
})
onMounted(() => {
    loadData()
})
const loadData = () => {
    state.loading = true
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/serverCenter/workorder',
        method: 'post',
        data: Object.assign({ page: pagination.current, limit: pagination.pageSize, token: props.detailData.token, customer_id: props.detailData.customer_id }, queryParam)
    }
    baseService(requestParam).then((res) => {
        state.loading = false
        pagination.total = res.data.total_records
        dataSource.value = res.data.list.map((item) => ({ ...item, isDetail: false }))
    })
}
const onChange = (val) => {
    pagination.pageSize = val.pageSize
    pagination.current = val.current
    loadData()
}
const handleDetail = (record) => {
    state.detailData = record
    state.showDetail = true
}
const oncancel = () => {
    state.showDetail = false
}
const onFormSubmit = () => {
    emit('cancel')
}
const cancel = () => {
    emit('cancel')
}
const formLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 10 }
    }
}
</script>
<style lang="less" scoped></style>
